import styled from 'styled-components';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';

export const CampaignGrid = styled(Flex)
    .withConfig({
        displayName: 'CampaignGrid',
    })
    .attrs((props) => ({
        ...props,
        direction: 'column',
    }))`
`;

export const PartFlex = styled(Flex)
    .withConfig({
        displayName: 'PartFlex',
    })
    .attrs((props) => ({
        ...props,
        direction: 'row',
        spacing: { xs: 2, sm: 3 },
    }))``;

export const CampaignColumn = styled(Flex).withConfig({
    displayName: 'CampaignColumn',
})``;

export const ColumnHeader = styled(Typography)
    .withConfig({
        displayName: 'ColumnHeader',
    })
    .attrs({
        variant: 'body2',
        weight: 'bold',
        mb: 0.5,
        lines: 1,
    })``;

export const ColumnValue = styled(Typography)
    .withConfig({
        displayName: 'ColumnValue',
    })
    .attrs((props) => ({
        ...props,
        variant: 'body2',
        lines: 1,
    }))``;
